// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// This can all probably be refactored to improve the readability

import ahoy from "ahoy.js";

ahoy.configure({
  visitsUrl: "/api/insights/init" + window.location.search,
  eventsUrl: "/api/insights/active" + window.location.search
})

import "@hotwired/turbo-rails";
import "@shoelace-style/shoelace";
import '@shoelace-style/shoelace/dist/themes/light.css';

import { Turbo } from "@hotwired/turbo-rails";
Turbo.session.drive = false;

import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();
const controllers = import.meta.glob("../controllers/*_controller.js", { eager: true });
registerControllers(application, controllers)

// Import Svelte page layouts, views, and components
// import.meta.globEager("../**/*.svelte");
void import.meta.glob(["../**/*.svelte"], { eager: true });

// Import ViewComponent sidecar components
// import.meta.globEager("../../components/**/*_component.js");
void import.meta.glob("../../components/**/*_component.js", { eager: true });

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Namespace for global variables/functions
window.BTPLUS ||= {}

// prevent the "content missing" message from being displayed
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault();
});

// Add CSRF token to all Turbo requests
document.addEventListener("turbo:before-fetch-request", (event) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  if (token) {
    event.detail.fetchOptions.headers["X-CSRF-Token"] = token;
  }
});

// When the page is loaded, find all links that point to 'edge.bigthink.com' and
// rewrite them to use relative URLs instead of absolute URLs. This is necessary
// because the ID team has used absolute URLs in some places, and we need to
// make sure that those links don't break when we're in staging or on the new
// platform. We need this to happen whether or not the page is loaded via Turbo.

// Some of the text content uses assets.edge.bigthink.com links to link to pdf downloads
// So we need to not apply the rewrite for those links
function rewriteEdgeLinks() {
  const links = document.querySelectorAll("a[href*='edge.bigthink.com']:not([href*='assets.edge.bigthink.com'])");

  links.forEach((link) => {
    const url = new URL(link.href);
    const path = url.pathname + url.search + url.hash;
    link.setAttribute("href", path);
  });
}

document.addEventListener("turbo:load", rewriteEdgeLinks);
document.addEventListener("DOMContentLoaded", rewriteEdgeLinks);

// Reports any images that don't load to Sentry
// Once we're reasonably certain images are loading for China users, remove this
if (window.location.host.endsWith('.cn')) {
  document.addEventListener('error', (event) => {
    const el = event.target;
    if (!(el instanceof HTMLImageElement)) return;
    if (!window.Sentry) return;

    // eslint-disable-next-line no-undef
    Sentry.captureMessage('Image failed to load', {
      level: 'warning',
      extra: {
        src: el.currentSrc || el.src,
        page: window.location.href,
        host: window.location.host,
      }
    });
  }, true);
}

import { sessionTimeout } from "../utils/sessionTimeout";
sessionTimeout();

export { application };
